import { Vector2, Vector3 } from '@anov/3d-core'

const thermalMagingShader = {
  uniforms: {
    tDiffuse: { value: null },
    iResolution: { value: new Vector2(1, 1) },
    colorLevels: { value: [new Vector3(234.0, 51.0, 61.0), new Vector3(235.0, 70.0, 105.0), new Vector3(178.0, 119.0, 37.0), new Vector3(247.0, 206.0, 70.0), new Vector3(149.0, 232.0, 71.0), new Vector3(103.0, 200.0, 250.0), new Vector3(68.0, 132.0, 245.0), new Vector3(40.0, 3.0, 143.0), new Vector3(18.0, 5.0, 62.0)] },
  },
  vertexShader: /* glsl */`
        varying vec2 vUv;
        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,
  fragmentShader: /* glsl */`
        uniform sampler2D tDiffuse;
        uniform vec3 colorLevels[9];
        varying vec2 vUv;

        void main() {
            vec4 color = texture2D(tDiffuse, vUv);

            color.rgb += vec3(1.0, 0.0, 0.5) * color.rgb * 0.2;

            float lum = dot(color.rgb, vec3(0.3, 0.59, 0.11));
            lum = 1.0 - lum;

            float d = 1.0 / 9.0;
            int i = int(lum / d);
            i = clamp(i, 0, 8);

            gl_FragColor = vec4(colorLevels[i] / 255.0, 1.0);
        }
    `,
}

export default thermalMagingShader
